export default {
  ja:[
    "ここからメッセージが送れるよ",
    "なずな",
    "質問などがあったら送ってみよう！",
    "メッセージを入力してね！",
    "送信"
  ],
  en: [
    "Send your message here",
    "Nazuna",
    "Your conversation will be shown here!",
    "Write a message here to contact the user!",
    "post"
  ]
}
